/* ---------------------------------------------------------------------------
 * Club 1984 — built by Fabrik
 * https://fabrik.ae
 *
 * Growth studio for fashion and footwear brands.
 * Design, build and merchandising systems on Shopify.
 * ------------------------------------------------------------------------- */

/* Club 1984 — drop landing page (phase 3).

   Two jobs, both optional. The date is already on the page as text and the
   form already works as a plain form post, so if this file never loads the
   page still tells you when the drop is and still signs you up. */
(function () {
  'use strict';

  /* ---- drop switchover ------------------------------------------------- */
  /* Counts reload attempts so the retry above cannot run away. Reset as soon
     as the page comes back in a sane state - either the drop has landed and
     there is no clock left, or the clock is still counting down. */
  var RELOADS = 'c84-drop-reloads';
  var pending = document.querySelector('[data-c84-countdown]');
  if (!pending || Date.parse(pending.getAttribute('data-c84-countdown')) > Date.now()) {
    try { sessionStorage.removeItem(RELOADS); } catch (e) {}
  }
  /* The cache-busting parameter has done its job by the time this runs. Taken
     back out of the address bar so nobody copies or shares a link with it. */
  if (location.search.indexOf('c84=') !== -1 && window.history && history.replaceState) {
    var clean = new URL(location.href);
    clean.searchParams.delete('c84');
    history.replaceState(null, '', clean.pathname + clean.search + clean.hash);
  }

  /* ---- countdown ------------------------------------------------------ */
  document.querySelectorAll('[data-c84-countdown]').forEach(function (el) {
    var target = Date.parse(el.getAttribute('data-c84-countdown'));
    if (isNaN(target)) return;

    var clock = el.parentElement.querySelector('[data-c84-clock]');
    if (!clock) return;

    var units = {
      days: clock.querySelector('[data-unit="days"]'),
      hours: clock.querySelector('[data-unit="hours"]'),
      minutes: clock.querySelector('[data-unit="minutes"]'),
      seconds: clock.querySelector('[data-unit="seconds"]')
    };
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    var tick = function () {
      var left = target - Date.now();
      if (left <= 0) {
        clock.hidden = true;
        /* The drop is live. Which slide shows is decided server side, so the
           page is reloaded rather than half-updated in place.

           A plain location.reload() was not enough. The response can come back
           from cache still showing the countdown, and a single attempt then
           leaves the page stuck on a clock reading zero - the one state worse
           than no clock at all. So the reload carries a changing parameter to
           force a fresh render, and retries a few times if it comes back
           unchanged. Bounded, because a reload loop on a live storefront is a
           far worse failure than a slide that is a minute late. */
        if (!clock.dataset.done) {
          clock.dataset.done = '1';
          var tries = 0;
          try { tries = parseInt(sessionStorage.getItem(RELOADS) || '0', 10) || 0; } catch (e) {}
          if (tries < 6) {
            try { sessionStorage.setItem(RELOADS, String(tries + 1)); } catch (e) {}
            var u = new URL(location.href);
            u.searchParams.set('c84', String(Date.now()));
            setTimeout(function () { location.replace(u.toString()); }, tries ? 3000 : 0);
          }
        }
        return;
      }
      var s = Math.floor(left / 1000);
      /* Padded like the rest. The reference reads 01D, not 1D, and an
         unpadded first unit makes the row jump a character wide when it ticks
         over. */
      units.days.textContent = pad(Math.floor(s / 86400));
      units.hours.textContent = pad(Math.floor(s % 86400 / 3600));
      units.minutes.textContent = pad(Math.floor(s % 3600 / 60));
      units.seconds.textContent = pad(s % 60);
      clock.hidden = false;
    };
    tick();
    setInterval(tick, 1000);
  });

  /* ---- the customer's own local time ----------------------------------- */
  /* The date on the page carries the shop's zone, which is correct but is not
     what a customer reads. Someone in Dubai sees "19:00 BST" and, at a glance,
     takes it for seven in the evening where they are. So the browser - which is
     the only thing that actually knows where they are - says it plainly.

     Shown only when it differs, so it never states the obvious. */
  document.querySelectorAll('[data-c84-localtime]').forEach(function (el) {
    var timeEl = el.parentElement.querySelector('[data-c84-countdown]');
    if (!timeEl) return;
    var when = new Date(Date.parse(timeEl.getAttribute('data-c84-countdown')));
    if (isNaN(when.getTime())) return;

    var shopStamp = timeEl.getAttribute('data-c84-countdown');
    /* the shop's own wall-clock reading, taken from the stamp itself */
    var shopHM = (shopStamp.match(/T(\d{2}:\d{2})/) || [])[1];
    var localHM = when.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    if (!shopHM || shopHM === localHM) return;   /* same clock reading: say nothing */

    var zone = '';
    try { zone = Intl.DateTimeFormat().resolvedOptions().timeZone.split('/').pop().replace(/_/g, ' '); }
    catch (e) { zone = ''; }

    var sameDay = when.toDateString() === new Date(Date.parse(shopStamp)).toDateString();
    el.textContent = 'That is ' + when.toLocaleString([], {
      weekday: sameDay ? undefined : 'short',
      hour: '2-digit', minute: '2-digit', hour12: false
    }) + (zone ? ' in ' + zone : ' your time');
    el.hidden = false;
  });

  /* ---- keep the sign-up on the first screen -------------------------------

     The picture is the only flexible thing on this layout, so it gives up
     whatever room the words need rather than the words being pushed under the
     fold. What sits above the section - announcement bar, header, nav - varies
     by page and by breakpoint, so it is measured rather than assumed; a fixed
     header height would be wrong on any page that also carries an announcement.

     A floor on the image stops it collapsing to nothing on a very short screen.
     If something has to give there, it should be the photograph and not the ask. */
  var stacked = document.querySelectorAll('.c84-drop--stacked');
  if (stacked.length) {
    var fit = function () {
      for (var i = 0; i < stacked.length; i++) {
        var sec = stacked[i];
        var above = sec.getBoundingClientRect().top + window.pageYOffset;
        sec.style.setProperty('--c84-above', Math.max(0, Math.round(above)) + 'px');
      }
    };
    /* Debounced through a frame. Reading the offset straight out of a resize
       handler gave a stale number - the browser had not finished laying the new
       viewport out, so the value belonged to the previous one and the picture
       was sized for a screen that no longer existed. */
    var queued = false;
    var schedule = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; fit(); });
    };

    fit();
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(schedule); }

    /* The chrome above can change height without the window resizing - an
       announcement bar rotating, a nav wrapping to two lines. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      var above = document.querySelector('.shopify-section-group-header-group');
      if (above) ro.observe(above);
      ro.observe(document.body);
    }
  }

  /* The sign-up needs no script. It is Shopify's own customer form now, so it
     posts on its own - which is also why it works with JavaScript off. */

})();
